<script setup lang="ts">
import { useStore } from '@/store/store'
const store = useStore()
store.commit('setPageTitle', 'Infrastructure')
</script>

<template>
  <q-page padding class="page"> </q-page>
</template>
